module.exports = __webpack_public_path__ + "static/media/drop-gold.b4c81792.svg";